<h2 mat-dialog-title>
    {{ 'empty_taskbook_dialog.title' | translate }} {{teamName}}
</h2>

<div mat-dialog-content class="px-5 py-3">
    <div class="row">
            @if(hasMoreItemsInOtherTeams){
                <p class="text-center">{{ 'empty_taskbook_dialog.info1' | translate }}</p>
                <p class="text-center">{{ 'empty_taskbook_dialog.countdown1' | translate }} <span class="fw-bold fs-5 text-secondary">{{countdown}}s</span>
            }@else {
                <p class="alert alert-success w-100">{{ 'empty_taskbook_dialog.desc' | translate }}</p>
                <p class="text-center">{{ 'empty_taskbook_dialog.info_backlog1' | translate }} <span class="fw-bold fs-5 text-secondary">{{countdown}}s</span> {{ 'empty_taskbook_dialog.info_backlog2' | translate }}
            }
    </div>    
</div>

<mat-dialog-actions class="justify-content-end">
    <button type="button"
            class="btn btn-default"
            (click)="cancel()">{{'cancel' | translate}}</button>
    <button type="button"
            class="btn btn-primary"
            (click)="go()">{{'empty_taskbook_dialog.go' | translate}}</button>
</mat-dialog-actions>